import { render, staticRenderFns } from "./DataLog.vue?vue&type=template&id=c8e6b548&scoped=true&"
import script from "./DataLog.vue?vue&type=script&lang=ts&"
export * from "./DataLog.vue?vue&type=script&lang=ts&"
import style0 from "./DataLog.vue?vue&type=style&index=0&id=c8e6b548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e6b548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAutocomplete,VBtn,VDataTable,VIcon,VPagination})
